/*
 Created by CHT 2020/10/11 10:14
 评分
 */

import BaseItem from "../BaseItem"
import {
  DATA_TYPE__NUMBER,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FORMULA,
  DEFAULT_VALUE__RELATE_DATA,
  FORM_ITEM__GRADE, FORM_ITEM__TABLE
} from "../types"
import {defaultValueInit} from "../utils"

class Grade extends BaseItem {
  constructor() {
    super()

    this.value = 0

    this.readonly = 0 				 // 是否只读
    this.initialValue = 0 		 // 初始值
    this.minValue = 0 				 // 最小值
    this.maxValue = 5 			 	 // 最大值
    this.halfChoose = 0				 // 允许半选
    this.assistTexts = [] 		 //	辅助文字
    this.setupColor = 1				 // 是否设置选中颜色
    this.selectColors = [
      '#F7BA2A',
      '#F7BA2A',
      '#F7BA2A'
    ]		 // 选中颜色
    this.uncheckColor = '' 		 // 未选中颜色

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || Grade._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

Grade._title = '评分'
Grade.type = FORM_ITEM__GRADE
Grade.use = true
Grade.icon = 'iconfont icon-pingfen'

Grade.prototype.type = Grade.type
Grade.prototype.dataType = DATA_TYPE__NUMBER
Grade.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM)
  },
  {
    label: '公式',
    value: defaultValueInit(DEFAULT_VALUE__FORMULA)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
Grade.prototype.assistTextAllList =  [
  {
    label: '极差',
    value: '极差'
  },
  {
    label: '失望',
    value: '失望'
  },
  {
    label: '一般',
    value: '一般'
  },
  {
    label: '满意',
    value: '满意'
  },
  {
    label: '惊喜',
    value: '惊喜'
  }]

Grade.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Grade.prototype.getValue = function () {
  return this.value
}
Grade.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || 0
}
Grade.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    readonly: this.readonly,
    initialValue: this.initialValue,
    minValue: this.minValue,
    maxValue: this.maxValue,
    halfChoose: this.halfChoose,
    assistTexts: this.assistTexts,
    setupColor: this.setupColor,
    selectColors: this.selectColors,
    uncheckColor: this.uncheckColor,
    defaultValue: this.defaultValue
  }
}
Grade.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.readonly) this.readonly = opts.readonly
  if (opts.initialValue) this.initialValue = opts.initialValue
  if (opts.minValue) this.minValue = opts.minValue
  if (opts.maxValue) this.maxValue = opts.maxValue
  if (opts.halfChoose) this.halfChoose = opts.halfChoose
  if (opts.assistTexts) this.assistTexts = opts.assistTexts
  this.setupColor = opts.setupColor
  if (opts.selectColors) this.selectColors = opts.selectColors
  if (opts.uncheckColor) this.uncheckColor = opts.uncheckColor
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
}
Grade.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}
export default Grade
